export const taxType = [
    {label: 'VAT 19%' , value: 19},
    {label: 'VAT 7%' , value: 7},
    {label: 'VAT 0%', value: 0}
];
// Utility to reindex a map after deletion
export function reindexMap<T>(map: { [key: number]: T }, list: any[]): { [key: number]: T } {
    const newMap: { [key: number]: T } = {};
    list.forEach((_, i) => {
      newMap[i] = map[i];
    });
    return newMap;
  }